import { FC } from 'react';
// components
import EditFlavorComponent from 'components/main/FlavorSystem/Edit';

const EditFlavor: FC = () => <EditFlavorComponent />;

export default EditFlavor;
